import { Directive } from 'vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const basicDateDirective: Directive = {
  mounted(el, binding) {
    const date = binding.value
    const formattedDate = dayjs.utc(date).format('DD/MM/YYYY')
    el.textContent = formattedDate
  },
}

export default basicDateDirective
